import React, { useEffect, useState } from "react"

import authStore from "mobx/AuthStore"
import { portalStatus, updatePortalStatus } from "services/UserService"
function PortalStatus() {
	const [state, setState] = useState("Open");
	const handlePortalStatus = async (status) => {
		const update = await updatePortalStatus({status});
		if(!update.error) getPortalStatus();
	}
	const getPortalStatus = async () => {
			const info = await portalStatus();
			if(!info.error){
				if(info.data.loanPortal.toLowerCase() === "open") setState("Close")
				else setState("Open")
			}
	}
	useEffect(() => {
		getPortalStatus();
	});

	return (
		<div className="mt-6">
			<p className="text-2xl text-primary font-bold">Change Portal Status</p>
				<button className="bg-primary text-white px-6 py-2 rounded-lg" type="submit" onClick={e =>handlePortalStatus(e.target.value)} value={state} disabled={authStore.isLoading ? true : false}>
					{authStore.isLoading ? "Loading..." : `${state}`}
				</button>
		</div>
	)
}

export default PortalStatus
